import React from "react";

export const DatePickerV2 = React.lazy(() => import("./DatePicker.v2"))
export const DateRangePicker = React.lazy(() => import("./DateRangePicker"))
export default React.lazy(() => import("./DatePicker"));
